import { selectCognitoUser } from "../../state/selectors";
import { getState } from "../../state/store";

import { intelligentDashboardAvailabilityRoles } from "../../consts";
import appUserService from "../appUser/appUserService";
import httpClient from "../httpClient";

const apiUrl = process.env.REACT_APP_API_URL;

const getRequestData = (endpoint) => {
  return `${apiUrl}/monitoring/${endpoint}`;
};

const fetchAvailableDashboards = async () => {
  const url = getRequestData("get-intelligent-dashboards");

  const { data } = await httpClient.get(url);

  return data;
};

const generateEmbedUrl = async (id) => {
  const url = getRequestData("generate-embed-url");

  const body = {
    dashboardId: id
  };

  const { data } = await httpClient.post(url, {
    data: body
  });

  return data.url;
};

const generateEmbedUrlQna = async () => {
  const url = getRequestData("generate-embed-url-qna");

  const { data } = await httpClient.post(url);

  return data.url;
};

const getFeatureAvailability = () => {
  const user = selectCognitoUser()(getState());

  if (!user) {
    return false;
  }

  const roles = appUserService.getRoles();
  const result =
    roles.some((role) => intelligentDashboardAvailabilityRoles.includes(role)) &&
    JSON.parse(user.signInUserSession?.idToken?.payload["canUseIntelligentDashboards"] ?? "{}");

  return result;
};

const smartDashboardService = {
  fetchAvailableDashboards,
  generateEmbedUrl,
  generateEmbedUrlQna,
  getFeatureAvailability
};

export default smartDashboardService;
